import { render, staticRenderFns } from "./BasketProductActions.vue?vue&type=template&id=2efdf5b6&scoped=true&"
import script from "./BasketProductActions.vue?vue&type=script&lang=js&"
export * from "./BasketProductActions.vue?vue&type=script&lang=js&"
import style0 from "./BasketProductActions.vue?vue&type=style&index=0&id=2efdf5b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efdf5b6",
  null
  
)

export default component.exports